import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCStemMetaPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-6187" data-mp="3b8gvh4x1c56a">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-6188" data-mp="6sfph8bnr9x8">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-6189" data-mp="br0tzjxy0frh">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-6190" data-mp="21h4vwjmzpo6">
              <XIcon className="w-6 h-6" data-id="element-6191" data-mp="pp795iv43r1t" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-6192" data-mp="uitm7c56twy5">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-video" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-6193" data-mp="37mmhcwmbyfmw"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-6194" data-mp="3mb8x2zfvd9en">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-6195" data-mp="44l0jxyvxukl">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-6196" data-mp="3vea02r9fuke3" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-6197" data-mp="4wumxc115q2i">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-6198" data-mp="iw3s7gnp6zrp">
        <div className="flex justify-center md:justify-between items-center" data-id="element-6199" data-mp="nuosfg2y9jg5">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-6200" data-mp="nskqv4siwwj1" />
          <div className="hidden md:block" data-id="element-6201" data-mp="11ltsuke56frj">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-6202" data-mp="11lk573gkkkp0">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-6203" data-mp="1gp3e0iwr8hkf">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-6204" data-mp="17q89db9czfj8">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-6205" data-mp="24dmnv2vgd2em">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-6206" data-mp="2n55lsvamdq9s">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-6207" data-mp="22v4fxm3cdpnn">
        <div className="md:col-span-7" data-id="element-6208" data-mp="27tfq5xxju26e">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-6209" data-mp="1tw9a4b47mhkv">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-6210" data-mp="1xzffzhneu6qt">
            Wat probeert je hond je te zeggen?
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-6211" data-mp="2qkyt64rkpg8f">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-6212" data-mp="34kqden8onsuv">
            <div className="flex -space-x-3" data-id="element-6213" data-mp="39d1f9vmzhoq2">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6214" data-mp="39dszkab4s011" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6215" data-mp="17nvgyw99g6ll" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-6216" data-mp="eywxnvteiyep" />
            </div>
            <div data-id="element-6217" data-mp="jwq1ii78fgbt">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-6218" data-mp="jw6lj715720f">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-6219" data-mp="20b82d33oq8db">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-6220" data-mp="1vf10bleeth0n">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om hun hond te
            begrijpen.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-6221" data-mp="2cflwu340s9y5">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-6222" data-mp="15vvr8fdofso9" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-6223" data-mp="3j7glq8ktqlpy" />
                <span className="text-gray-700 font-medium" data-id="element-6224" data-mp="3f6n2hsibtv3e">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-6225" data-mp="3a6igjmyng85s">
            <div className="flex -space-x-3" data-id="element-6226" data-mp="3598kvpko309i">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6227" data-mp="3587c5rr4ipuy" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6228" data-mp="2rh2egv7bg7n9" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-6229" data-mp="2hicxd4n8ur82" />
            </div>
            <div data-id="element-6230" data-mp="9apvqdnti0l2">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-6231" data-mp="9950smxlcfmo">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-6232" data-mp="3rgukgr8v87et">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-6233" data-mp="bl1vkn7avf8">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-6234" data-mp="3hpggo79vslfv">
            <div className="flex justify-center items-center w-full" data-id="element-6235" data-mp="3mhhuvyqm0m8j">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-video" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-6236" data-mp="38pjvifmpa4pk"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-6237" data-mp="2g569z2mnaecj">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-6238" data-mp="2u34n64p8c4qg">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-6239" data-mp="2u0i9rofnqv0b">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-6240" data-mp="332hrkiyhy34b">
            <div className="flex flex-col items-center" data-id="element-6241" data-mp="2z27j8zn8f0ma">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-6242" data-mp="2z1pefemi7e2r" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6243" data-mp="3mrjqvv2wv0mh">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-6244" data-mp="3mpfoxiokobou">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-6245" data-mp="17l69gmmokg1g">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-6246" data-mp="17mpqwgk2ox4t" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6247" data-mp="ttrls2htvqo2">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-6248" data-mp="1qjilcg4z840q">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-6249" data-mp="1libdyi6qx6ul">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-6250" data-mp="1hhrayxzhr90j" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-6251" data-mp="61avj4nxssdo">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-6252" data-mp="139cukufav2q">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-6253" data-mp="2hs26jca3y3im">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-6254" data-mp="2vki25s0oiz9i">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-6255" data-mp="30gpa1qcmyku3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-6256" data-mp="30jbevi856m8m">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-6257" data-mp="39fua513uim8d" />
            <span className="italic" data-id="element-6258" data-mp="1b2twm3wrio3n">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-6259" data-mp="1f3duj9p5tvqu">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6260" data-mp="1f5yxk2172hq6">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6261" data-mp="2ifbhekfzpgsa">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-6262" data-mp="2rfzth9ltp72j"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6263" data-mp="3k5girye5c7uj">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6264" data-mp="3f5u6br656vms">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-6265" data-mp="2jn2x7v35s43"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-6266" data-mp="360lue30uwisl">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-6267" data-mp="3b1t1s0z37fyq">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-6268" data-mp="3214nd55s7dlb"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-6269" data-mp="26cxjlnccqtxj">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6270" data-mp="21c027cz623x3">
              <div className="flex items-center mb-4" data-id="element-6271" data-mp="1xb7skimdtx0a">
                <div className="flex text-green-500 mr-2" data-id="element-6272" data-mp="3vpiykjhgnggt">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6273" data-mp="3rne45ij6uft4" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6274" data-mp="1dgy2osoes8uc">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6275" data-mp="1ieps9g1kzivd">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6276" data-mp="1r7jmcjlosmta">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6277" data-mp="2ezi0dbciswa4">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6278" data-mp="jtfvjea5q182">
              <div className="flex items-center mb-4" data-id="element-6279" data-mp="fsnlwjxdhub9">
                <div className="flex text-green-500 mr-2" data-id="element-6280" data-mp="fs473c30rm1g">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6281" data-mp="tq2g01ykmq9k" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6282" data-mp="or90k3zq4p6r">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6283" data-mp="1150u7pnp9l1">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6284" data-mp="at10vobaz9rw">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6285" data-mp="1g1lnc10m2ips">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6286" data-mp="1k02z4xuz8hdj">
              <div className="flex items-center mb-4" data-id="element-6287" data-mp="27sjev1r8rx9o">
                <div className="flex text-green-500 mr-2" data-id="element-6288" data-mp="2cr33j9x7zn5q">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6289" data-mp="1yq0firmo02s6" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6290" data-mp="23ottel5v5vsv">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6291" data-mp="nav8jbfi3i2r">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6292" data-mp="1j133n79zky0k">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6293" data-mp="1o0o1tfhc12c8">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-6294" data-mp="2lgbp2uq24zz5">
              <div className="flex items-center mb-4" data-id="element-6295" data-mp="2gns9xtbq1ws8">
                <div className="flex text-green-500 mr-2" data-id="element-6296" data-mp="2nzzolihuv5wp">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-6297" data-mp="2syt1b8pbisvt" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-6298" data-mp="2xxmgr6o60tym">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-6299" data-mp="32xs1e2w0pg77">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6300" data-mp="36yav62hh0wc1">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-6301" data-mp="3lnqkrf59mvq5">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-6302" data-mp="3qo4l0b0ml1dm">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-6303" data-mp="130blyje5uty8">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-6304" data-mp="17wsle9qt8uqm">
          <div data-id="element-6305" data-mp="1bynonjsaxi71">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-6306" data-mp="1bz5pyuttmmlt">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-6307" data-mp="1lx3ezkji8nfh">
              <p data-id="element-6308" data-mp="1lv8ta40esrac">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-6309" data-mp="24nkswizohegs">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-6310" data-mp="3g71heqreko7k">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-6311" data-mp="3u2m2nsultii5">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-6312" data-mp="1ei9ymoreh7la">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-6313" data-mp="qspbrus4lq6q">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-6314" data-mp="vstr3hhasevd" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-6315" data-mp="2c6k2l9aqy5f1">
        <div className="max-w-md mx-auto px-4" data-id="element-6316" data-mp="2c7v1ovt8yozt">
          <div className="p-6 rounded-3xl w-full" data-id="element-6317" data-mp="2g96utbbbxscr">
            <div className="flex justify-center items-center" data-id="element-6318" data-mp="2g7vr1bhvwkln">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-video" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-6319" data-mp="4md61y719ovx"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-6320" data-mp="jcbzjnnn8c52">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-6321" data-mp="x8pk55nh4tnr">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-6322" data-mp="sbz58lneo43x" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-6323" data-mp="2u4dkte2h8wh6">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-6324" data-mp="30ij0upk855k3">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-6325" data-mp="35fjbzevxkyi2">
            <p className="mb-2" data-id="element-6326" data-mp="3ag709ssrz18l">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-6327" data-mp="2cqviiw1132tf">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-6328" data-mp="1mieli7cymgz5" />
    </div>;
}